import { useState } from "react";
import { useTranslation } from "react-i18next";
import { X } from "lucide-react";

import intro from "../../assets/images/magicPen/intro.gif";
import SlideInAnimation from "../../components/animation/SlideInAnimation";
import GameTitle from "../../components/game/GameTitle";
import Text from "../../components/ui/Text";
import Touchable from "../../components/ui/Touchable";

import DisneyButton from "./components/DisneyButton";
import PenImage from "./components/PenImage";
import TryItCard from "./components/TryItCard";

export default function MagicPenHome() {
  const { t } = useTranslation();

  const [showPens, setShowPens] = useState(false);

  return (
    <div className="flex w-full flex-1 flex-col">
      <div className="mx-auto flex w-full max-w-[480px] flex-col">
        <GameTitle text="Magic Pen" />

        <div className="mt-2 px-6 pb-4">
          <Text normal>{t("magicPenDesc")}</Text>
        </div>

        <div className="relative w-full">
          <img
            src={intro}
            alt="intro"
            className="h-[390px] w-full object-cover tablet:h-[480px]"
          />

          <div className="absolute inset-0 flex flex-col justify-between px-6 py-4">
            <Text
              className="text-2xl text-white"
              style={{ textShadow: "0px 2px 4px rgba(0, 0, 0, 0.5)" }}
            >
              {t("magicPenVideoTitle")}
            </Text>
          </div>
        </div>
      </div>

      <div className="flex flex-1 justify-center bg-gradient-to-b from-[#FDE0C8] to-pink1 py-4 tablet:py-[60px]">
        <TryItCard onClick={() => setShowPens(true)} />
      </div>

      <SlideInAnimation
        isVisible={showPens}
        className="fixed inset-x-0 bottom-0 mx-auto flex h-[486px] w-full max-w-[834px] flex-col items-center gap-6 rounded-t-3xl bg-gradient-to-t from-pink2 to-pink1 pt-3"
      >
        <div className="relative flex h-11 w-full items-center justify-center">
          <Text lg>{t("chooseYourMagicPen")}</Text>

          <Touchable
            className="absolute right-0 top-0 mx-4 my-2.5"
            onClick={() => setShowPens(false)}
          >
            <X className="size-6" />
          </Touchable>
        </div>

        <div className="flex w-full max-w-[480px] flex-col gap-6">
          <div className="flex h-[270px] justify-around px-10">
            <PenImage type="mickey" />
            <PenImage type="minnie" />
          </div>

          <div className="flex h-[54px] justify-around px-9">
            <DisneyButton type="mickey" />
            <DisneyButton type="minnie" />
          </div>
        </div>
      </SlideInAnimation>
    </div>
  );
}
